// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar default styles */
.sidebar {
  width: 282px;
  height: 100%;
  transition: all ease-in 0.3s;
  border-right: #dee3e9;
  border-style: solid;
  border-width: 1px;
  padding-top: 20px;
  padding-left: 20px;
  overflow-y: hidden;
  scrollbar-width: none;
  scrollbar-color: #aab7cf transparent;
  background-color: #FFFFFF;
  z-index: 999; /* Ensure sidebar is on top but below tooltip */
  display: flex;
  flex-direction: column; /* Ensures everything is aligned in a column */
  overflow: visible;
  border-top: none;
  backdrop-filter: blur(20px); /* The glass effect: creates blur behind the sidebar */
  -webkit-backdrop-filter: blur(10px); /* For Safari */
  border: 1px solid rgba(255, 255, 255, 0.3); /* Light border to enhance the glass effect */
  
}

.sidebar.closed {
  width: 80px; /* Adjusted width to better fit the icons */
  background-color: #F6F9FB;
  padding: 20px 0px 20px 0px; /* Adjusted padding to center icons vertically */
  align-items: center; /* Center align items if flex is used */
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #3c0b99 10%, #6a1b9a 40%, #4b0082 100%);
  backdrop-filter: blur(10px); /* The frosted glass blur */
  -webkit-backdrop-filter: blur(10px); /* Safari support */
  border: 1px solid rgba(255, 255, 255, 0.2); /* Light border for glass effect */
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  z-index: 1;
  position: relative;
  opacity: 0.9; /* Slight transparency */
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  margin-top: 0px;
  align-items: center;
  position: relative;
  padding-bottom: 10px;
}

.newChat{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 242px;  /* Assuming default width when sidebar is open */
  height: 40px; 
  border-radius: 5px; 
  background-color: #5e17eb;
  color: rgb(255, 255, 255); /* Default icon color when open */
  cursor: pointer; 
  border: none;
  margin-left: 0px;
  font-size: 14px;
  transition: all ease-in 0.3s;
}

.newChat:hover{
  background-color: #4a11c5;
}

.newChat.collapsed {
  width: 50px; /* Smaller, circular size for collapsed state */
  height: 50px;
  background-color: white; /* White icon */
  color: #5e17eb ;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Optional shadow */
  margin-right: 0px;
}

.newChat.collapsed:hover {
  color: #fff;
  background-color: #9b80d1; /* Darker blue on hover */
}

.newChat.collapsed i {
  font-size: 30px; /* Size of the "+" icon in collapsed state */
}

.icon-container { /* Or whatever your sidebar's container is */
  position: relative; /* This makes it the reference point for the absolutely positioned dropdown */
  margin-bottom: 15px;
}


.bi-plus-circle-fill {
  color: #ffffff; /* Icon color when sidebar is collapsed */
  font-size: 24px; /* Icon size when sidebar is collapsed */
}

.bi-gear { /* Style specifically for the gear icon */
  font-size: 24px;
  color: #3973E5;
}

.dropdown-container {
  margin-bottom: 16px;
  width: 242px;
  height: 40px;
  border-radius: 12px;
  transition: all ease-in 0.3s;
}

.dropdown-container:hover {
  cursor: pointer;
}

.dropdown{
  margin-left: 0px;
  width: 100%;
}

.sidebar-dropdown {
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  background-color: #72f4b1;
}

.toggle-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #888; /* Light gray color for the icon */
  position: relative; /* Ensure the tooltip is relative to the button */
}

.toggle-button:hover {
  color: #0b1a5b; /* Darker blue color on hover */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: transparent;
}

.new-chat-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: #888; /* Light gray color for the icon */
}

.new-chat-button:hover {
  color: #0b1a5b; /* Darker blue color on hover */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.options-menu {
  position: absolute;
  top: 0; /* Adjust this value to align vertically as needed */
  right: -200px; /* Positions the dropdown to the left of the container */
  width: 180px; /* Or whatever width you prefer */
  background-color: #ffffff;
  z-index: 1500;
  border-radius: 12px;
  border: 1px solid #dee3e9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
}

.options-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.options-menu li {
  padding: 8px 12px;
  cursor: pointer;
  color: #333;
}

.options-menu li:hover {
  background-color: #5e17eb;
  color: #E6E6FA;
}


.tooltip {
  position: fixed; /* Changed to fixed to keep it visible */
  top: 0  px; /* Adjust this based on the toggle button's position */
  left: 75px; /* Adjust this to position it outside the sidebar */
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.9;
  z-index: 1001; /* Ensure it's above the sidebar */
}

.tooltip::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -10px; /* Position the triangle */
  transform: translateY(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent #333 transparent transparent;
}

.message-box {
  margin-left: 10px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 0px;
}

.message-box i {
  font-size: 18px;
  color: #007bff;
  margin-right: 10px;
}

.chat-history-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 242px;
  height: 30px;
  margin-top: 20px;
  color: #1B2559;
  justify-content: center;
}

.chat-history-list{
  width: 95%;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width:none;
  padding: 10px;
  margin: 0;
  justify-content: center;
  border: 2px solid rgba(94, 23, 235, 0.3); /* 50% transparent purple border */
  border-radius: 10px;
}


.list-item {
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  color: #333;
  font-weight: normal;
  background-color: #ffffff;
}

.list-item:hover  {
  background-color: #f4f4f8;
}

.list-item.selected
{
  background-color: #e1e1e6;
}
.selected{
  background-color: #D0D7DF;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: background-color 0.3s;
  text-overflow: ellipsis;
  font-weight: normal;
  padding: 8px;
}
.session-icon {
  color: #424040;
  font-size: 20px;
  margin-right: 10px;
}

.session-info {
  flex-grow: 1;
}

.session-summary {
  font-size: 12px;
  color: #333;
}

.chat-history-list li:selected {
  background-color: #D0D7DF; /* Pressed/selected effect */
  font-weight: bold; /* Make it bold to highlight the selection */
}

.dropdown-menu {
  position: fixed;
  right: 0px;
  top: 20px; /* Position below the three-dots icon */
  background-color: #333; /* Background for dropdown */
  border: 1px solid #555; /* Border color */
  border-radius: 4px;
  padding: 8px;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5); /* Shadow for dropdown */
}

/* Dropdown item styles */
.dropdown-item {
  align-self: flex-end;
  z-index: 10;
  cursor: pointer;
  padding: 4px 8px;
  border: 1px solid #ccc; /* Subtle border */
  border-radius: 4px;
  color: #ff4a4a; /* Dropdown text color */
  transition: background-color 0.3s ease; /* Transition effect */
}

.dropdown-item:hover {
  background-color: #444; /* Hover effect for dropdown items */
}

/* Three dots vertical hover styling */
.three-dots-container {
  display: inline-block;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.3s ease; /* Smooth transition */
}

.three-dots-container:hover {
  background-color: #f0f0f0; /* Light gray background on hover */
  cursor: pointer; /* Pointer cursor on hover */
}

.deleteCov {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #E6E6FA;
  border-style: solid;
  border-color: #E2E8F0;
  border-width: 1px;
  margin-left: 16px;
  margin-top: 15px;
  cursor: pointer;
  border-radius: 12px;
  width: 200px;
  color: #000;
  transition: width 0.3s ease;
}

.deleteCov:hover{
  background-color:  #D0D7DF;
}

.sidebar.closed .deleteCov {
  width: 40px;
  margin-left: 0;
  justify-content: center;
}

.sidebar.closed .deleteCov div {
  display: none; /* Hide text when sidebar is closed */
}

.sidebar.closed .deleteCov i {
  margin: 0 auto; /* Center the icon in the button when sidebar is closed */
}

/* Dark mode styles */
body.dark-mode .sidebar {
  background-color: #1c1c1c; /* Darker background to match dark mode */
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.8); /* Enhanced shadow for more depth */
  border: 1px solid rgba(255, 255, 255, 0.1); /* Light border */
}

body.dark-mode .sidebar.closed {
  background: linear-gradient(135deg, #1e033d 10%, #3a0b5b 40%, #200026 100%);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px); /* Increased blur effect for more frosted glass feel */
  border: 1px solid rgba(255, 255, 255, 0.1); /* Light border for glass effect */
  opacity: 0.85;
}

body.dark-mode .sidebar-header {
  color: #e0e0e0; /* Light color for text */
}

body.dark-mode .dropdown-container {
  background-color: #333;
}

body.dark-mode .sidebar-dropdown {
  background-color: #333;
  border-color: #555;
  color: #e0e0e0; /* Light text color */
}

body.dark-mode .toggle-button {
  color: #bbb; /* Light gray color for the icon in dark mode */
}

body.dark-mode .toggle-button:hover {
  color: #ffcc00; /* Light amber color for dark mode */
}

body.dark-mode .new-chat-button {
  color: #bbb; /* Light gray color for the icon in dark mode */
}

body.dark-mode .newChat {
  background-color: #3a0b5b; /* Darker vivid purple shade */
  color: #ffffff; /* White icon color */
}

body.dark-mode .newChat:hover {
  background-color: #55188a; /* Slightly brighter shade for hover effect */
}

/* Icon colors in sidebar (collapsed) */
body.dark-mode .bi-plus-circle-fill {
  color: #ffffff; /* White icon for contrast */
}

body.dark-mode .bi-gear {
  color: #ffcc00; /* Amber gear icon for distinction in dark mode */
}

body.dark-mode .tooltip {
  background-color: #444;
  color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

body.dark-mode .tooltip::before {
  border-color: transparent #444 transparent transparent;
}

body.dark-mode .message-box {
  color: #e0e0e0;
}

body.dark-mode .message-box i {
  color: #80bfff; /* Lighter blue for icon in dark mode */
}

body.dark-mode .chat-history {
  background-color: #2f2f2f;
  scrollbar-color: #4f4f4f transparent;
}
body.dark-mode .selected{
  background-color: #4B4B4B;
}
body.dark-mode .list-item {
  background-color: #1e1e1e; /* Dark background for list items */
  color: #e0e0e0; /* Light text for visibility */
}

body.dark-mode .list-item:hover {
  background-color: #3a3a3a; /* Slightly lighter on hover */
}

body.dark-mode .list-item.selected {
  background-color: #3b3b3b; /* Highlighted state for selected list item */
}

body.dark-mode .chat-history-header {
  color: #e0e0e0; /* Light text color for dark mode */
}

body.dark-mode .deleteCov {
  background-color: #3b3b3b; /* Darker background for delete button */
  color: #ffffff; /* Light text */
}

body.dark-mode .deleteCov:hover {
  background-color: #4b4b4b; /* Slightly lighter background on hover */
}

/* Dropdown container */
body.dark-mode .dropdown-container {
  background-color: #2a2a2a; /* Dark background for dropdown */
  color: #e0e0e0; /* Light text for visibility */
}

body.dark-mode .dropdown-container:hover {
  background-color: #3a3a3a; /* Slightly lighter on hover */
}


@media (max-width: 720px) {
  .sidebar.closed {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,YAAY,EAAE,+CAA+C;EAC7D,aAAa;EACb,sBAAsB,EAAE,8CAA8C;EACtE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B,EAAE,sDAAsD;EACnF,mCAAmC,EAAE,eAAe;EACpD,0CAA0C,EAAE,6CAA6C;;AAE3F;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,yBAAyB;EACzB,0BAA0B,EAAE,gDAAgD;EAC5E,mBAAmB,EAAE,uCAAuC;EAC5D,aAAa;EACb,sBAAsB;EACtB,2EAA2E;EAC3E,2BAA2B,EAAE,2BAA2B;EACxD,mCAAmC,EAAE,mBAAmB;EACxD,0CAA0C,EAAE,kCAAkC;EAC9E,yCAAyC,EAAE,4BAA4B;EACvE,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE,wBAAwB;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,GAAG,gDAAgD;EAC/D,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB,EAAE,iCAAiC;EAC5D,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,+CAA+C;EAC5D,YAAY;EACZ,uBAAuB,EAAE,eAAe;EACxC,eAAe;EACf,qCAAqC,EAAE,oBAAoB;EAC3D,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,eAAe,EAAE,4CAA4C;AAC/D;;AAEA,kBAAkB,4CAA4C;EAC5D,kBAAkB,EAAE,6EAA6E;EACjG,mBAAmB;AACrB;;;AAGA;EACE,cAAc,EAAE,yCAAyC;EACzD,eAAe,EAAE,wCAAwC;AAC3D;;AAEA,WAAW,yCAAyC;EAClD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW,EAAE,kCAAkC;EAC/C,kBAAkB,EAAE,iDAAiD;AACvE;;AAEA;EACE,cAAc,EAAE,+BAA+B;EAC/C,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW,EAAE,kCAAkC;AACjD;;AAEA;EACE,cAAc,EAAE,+BAA+B;EAC/C,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,oDAAoD;EAC5D,aAAa,EAAE,wDAAwD;EACvE,YAAY,EAAE,iCAAiC;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,eAAe,EAAE,wCAAwC;EACzD,UAAU,EAAE,sDAAsD;EAClE,UAAU,EAAE,mDAAmD;EAC/D,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,0BAA0B;EACvC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,wCAAwC,EAAE,kCAAkC;EAC5E,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,iBAAiB,EAAE,4CAA4C;AACjE;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS,EAAE,uCAAuC;EAClD,sBAAsB,EAAE,4BAA4B;EACpD,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yCAAyC,EAAE,wBAAwB;AACrE;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB,EAAE,kBAAkB;EAC1C,kBAAkB;EAClB,cAAc,EAAE,wBAAwB;EACxC,sCAAsC,EAAE,sBAAsB;AAChE;;AAEA;EACE,sBAAsB,EAAE,oCAAoC;AAC9D;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC,EAAE,sBAAsB;AAChE;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,cAAc,EAAE,yDAAyD;AAC3E;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,yCAAyC;EACpE,uCAAuC,EAAE,mCAAmC;EAC5E,0CAA0C,EAAE,iBAAiB;AAC/D;;AAEA;EACE,2EAA2E;EAC3E,mCAA2B;UAA3B,2BAA2B,EAAE,sDAAsD;EACnF,0CAA0C,EAAE,kCAAkC;EAC9E,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;EACE,cAAc,EAAE,oCAAoC;AACtD;;AAEA;EACE,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,yBAAyB,EAAE,6CAA6C;AAC1E;;AAEA,uCAAuC;AACvC;EACE,cAAc,EAAE,4BAA4B;AAC9C;;AAEA;EACE,cAAc,EAAE,iDAAiD;AACnE;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,uCAAuC;AACzD;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,yBAAyB,EAAE,6CAA6C;AAC1E;;AAEA;EACE,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA,uBAAuB;AACvB;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;;AAGA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Sidebar default styles */\n.sidebar {\n  width: 282px;\n  height: 100%;\n  transition: all ease-in 0.3s;\n  border-right: #dee3e9;\n  border-style: solid;\n  border-width: 1px;\n  padding-top: 20px;\n  padding-left: 20px;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  scrollbar-color: #aab7cf transparent;\n  background-color: #FFFFFF;\n  z-index: 999; /* Ensure sidebar is on top but below tooltip */\n  display: flex;\n  flex-direction: column; /* Ensures everything is aligned in a column */\n  overflow: visible;\n  border-top: none;\n  backdrop-filter: blur(20px); /* The glass effect: creates blur behind the sidebar */\n  -webkit-backdrop-filter: blur(10px); /* For Safari */\n  border: 1px solid rgba(255, 255, 255, 0.3); /* Light border to enhance the glass effect */\n  \n}\n\n.sidebar.closed {\n  width: 80px; /* Adjusted width to better fit the icons */\n  background-color: #F6F9FB;\n  padding: 20px 0px 20px 0px; /* Adjusted padding to center icons vertically */\n  align-items: center; /* Center align items if flex is used */\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, #3c0b99 10%, #6a1b9a 40%, #4b0082 100%);\n  backdrop-filter: blur(10px); /* The frosted glass blur */\n  -webkit-backdrop-filter: blur(10px); /* Safari support */\n  border: 1px solid rgba(255, 255, 255, 0.2); /* Light border for glass effect */\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n  z-index: 1;\n  position: relative;\n  opacity: 0.9; /* Slight transparency */\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0px;\n  align-items: center;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.newChat{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 242px;  /* Assuming default width when sidebar is open */\n  height: 40px; \n  border-radius: 5px; \n  background-color: #5e17eb;\n  color: rgb(255, 255, 255); /* Default icon color when open */\n  cursor: pointer; \n  border: none;\n  margin-left: 0px;\n  font-size: 14px;\n  transition: all ease-in 0.3s;\n}\n\n.newChat:hover{\n  background-color: #4a11c5;\n}\n\n.newChat.collapsed {\n  width: 50px; /* Smaller, circular size for collapsed state */\n  height: 50px;\n  background-color: white; /* White icon */\n  color: #5e17eb ;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Optional shadow */\n  margin-right: 0px;\n}\n\n.newChat.collapsed:hover {\n  color: #fff;\n  background-color: #9b80d1; /* Darker blue on hover */\n}\n\n.newChat.collapsed i {\n  font-size: 30px; /* Size of the \"+\" icon in collapsed state */\n}\n\n.icon-container { /* Or whatever your sidebar's container is */\n  position: relative; /* This makes it the reference point for the absolutely positioned dropdown */\n  margin-bottom: 15px;\n}\n\n\n.bi-plus-circle-fill {\n  color: #ffffff; /* Icon color when sidebar is collapsed */\n  font-size: 24px; /* Icon size when sidebar is collapsed */\n}\n\n.bi-gear { /* Style specifically for the gear icon */\n  font-size: 24px;\n  color: #3973E5;\n}\n\n.dropdown-container {\n  margin-bottom: 16px;\n  width: 242px;\n  height: 40px;\n  border-radius: 12px;\n  transition: all ease-in 0.3s;\n}\n\n.dropdown-container:hover {\n  cursor: pointer;\n}\n\n.dropdown{\n  margin-left: 0px;\n  width: 100%;\n}\n\n.sidebar-dropdown {\n  width: 100%;\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n  background-color: #72f4b1;\n}\n\n.toggle-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 24px;\n  color: #888; /* Light gray color for the icon */\n  position: relative; /* Ensure the tooltip is relative to the button */\n}\n\n.toggle-button:hover {\n  color: #0b1a5b; /* Darker blue color on hover */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 5px;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  background-color: transparent;\n}\n\n.new-chat-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 24px;\n  color: #888; /* Light gray color for the icon */\n}\n\n.new-chat-button:hover {\n  color: #0b1a5b; /* Darker blue color on hover */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 5px;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.options-menu {\n  position: absolute;\n  top: 0; /* Adjust this value to align vertically as needed */\n  right: -200px; /* Positions the dropdown to the left of the container */\n  width: 180px; /* Or whatever width you prefer */\n  background-color: #ffffff;\n  z-index: 1500;\n  border-radius: 12px;\n  border: 1px solid #dee3e9;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 10px 0;\n}\n\n.options-menu ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.options-menu li {\n  padding: 8px 12px;\n  cursor: pointer;\n  color: #333;\n}\n\n.options-menu li:hover {\n  background-color: #5e17eb;\n  color: #E6E6FA;\n}\n\n\n.tooltip {\n  position: fixed; /* Changed to fixed to keep it visible */\n  top: 0  px; /* Adjust this based on the toggle button's position */\n  left: 75px; /* Adjust this to position it outside the sidebar */\n  background-color: #333;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  white-space: nowrap;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  opacity: 0.9;\n  z-index: 1001; /* Ensure it's above the sidebar */\n}\n\n.tooltip::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: -10px; /* Position the triangle */\n  transform: translateY(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent #333 transparent transparent;\n}\n\n.message-box {\n  margin-left: 10px;\n  padding: 0;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  margin-top: 0px;\n}\n\n.message-box i {\n  font-size: 18px;\n  color: #007bff;\n  margin-right: 10px;\n}\n\n.chat-history-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 242px;\n  height: 30px;\n  margin-top: 20px;\n  color: #1B2559;\n  justify-content: center;\n}\n\n.chat-history-list{\n  width: 95%;\n  height: 100%;\n  overflow-y: scroll;\n  scrollbar-width:none;\n  padding: 10px;\n  margin: 0;\n  justify-content: center;\n  border: 2px solid rgba(94, 23, 235, 0.3); /* 50% transparent purple border */\n  border-radius: 10px;\n}\n\n\n.list-item {\n  padding: 8px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  display: flex;\n  align-items: center;\n  color: #333;\n  font-weight: normal;\n  background-color: #ffffff;\n}\n\n.list-item:hover  {\n  background-color: #f4f4f8;\n}\n\n.list-item.selected\n{\n  background-color: #e1e1e6;\n}\n.selected{\n  background-color: #D0D7DF;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  text-overflow: ellipsis;\n  font-weight: normal;\n  padding: 8px;\n}\n.session-icon {\n  color: #424040;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.session-info {\n  flex-grow: 1;\n}\n\n.session-summary {\n  font-size: 12px;\n  color: #333;\n}\n\n.chat-history-list li:selected {\n  background-color: #D0D7DF; /* Pressed/selected effect */\n  font-weight: bold; /* Make it bold to highlight the selection */\n}\n\n.dropdown-menu {\n  position: fixed;\n  right: 0px;\n  top: 20px; /* Position below the three-dots icon */\n  background-color: #333; /* Background for dropdown */\n  border: 1px solid #555; /* Border color */\n  border-radius: 4px;\n  padding: 8px;\n  z-index: 100;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5); /* Shadow for dropdown */\n}\n\n/* Dropdown item styles */\n.dropdown-item {\n  align-self: flex-end;\n  z-index: 10;\n  cursor: pointer;\n  padding: 4px 8px;\n  border: 1px solid #ccc; /* Subtle border */\n  border-radius: 4px;\n  color: #ff4a4a; /* Dropdown text color */\n  transition: background-color 0.3s ease; /* Transition effect */\n}\n\n.dropdown-item:hover {\n  background-color: #444; /* Hover effect for dropdown items */\n}\n\n/* Three dots vertical hover styling */\n.three-dots-container {\n  display: inline-block;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background-color 0.3s ease; /* Smooth transition */\n}\n\n.three-dots-container:hover {\n  background-color: #f0f0f0; /* Light gray background on hover */\n  cursor: pointer; /* Pointer cursor on hover */\n}\n\n.deleteCov {\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: #E6E6FA;\n  border-style: solid;\n  border-color: #E2E8F0;\n  border-width: 1px;\n  margin-left: 16px;\n  margin-top: 15px;\n  cursor: pointer;\n  border-radius: 12px;\n  width: 200px;\n  color: #000;\n  transition: width 0.3s ease;\n}\n\n.deleteCov:hover{\n  background-color:  #D0D7DF;\n}\n\n.sidebar.closed .deleteCov {\n  width: 40px;\n  margin-left: 0;\n  justify-content: center;\n}\n\n.sidebar.closed .deleteCov div {\n  display: none; /* Hide text when sidebar is closed */\n}\n\n.sidebar.closed .deleteCov i {\n  margin: 0 auto; /* Center the icon in the button when sidebar is closed */\n}\n\n/* Dark mode styles */\nbody.dark-mode .sidebar {\n  background-color: #1c1c1c; /* Darker background to match dark mode */\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.8); /* Enhanced shadow for more depth */\n  border: 1px solid rgba(255, 255, 255, 0.1); /* Light border */\n}\n\nbody.dark-mode .sidebar.closed {\n  background: linear-gradient(135deg, #1e033d 10%, #3a0b5b 40%, #200026 100%);\n  backdrop-filter: blur(20px); /* Increased blur effect for more frosted glass feel */\n  border: 1px solid rgba(255, 255, 255, 0.1); /* Light border for glass effect */\n  opacity: 0.85;\n}\n\nbody.dark-mode .sidebar-header {\n  color: #e0e0e0; /* Light color for text */\n}\n\nbody.dark-mode .dropdown-container {\n  background-color: #333;\n}\n\nbody.dark-mode .sidebar-dropdown {\n  background-color: #333;\n  border-color: #555;\n  color: #e0e0e0; /* Light text color */\n}\n\nbody.dark-mode .toggle-button {\n  color: #bbb; /* Light gray color for the icon in dark mode */\n}\n\nbody.dark-mode .toggle-button:hover {\n  color: #ffcc00; /* Light amber color for dark mode */\n}\n\nbody.dark-mode .new-chat-button {\n  color: #bbb; /* Light gray color for the icon in dark mode */\n}\n\nbody.dark-mode .newChat {\n  background-color: #3a0b5b; /* Darker vivid purple shade */\n  color: #ffffff; /* White icon color */\n}\n\nbody.dark-mode .newChat:hover {\n  background-color: #55188a; /* Slightly brighter shade for hover effect */\n}\n\n/* Icon colors in sidebar (collapsed) */\nbody.dark-mode .bi-plus-circle-fill {\n  color: #ffffff; /* White icon for contrast */\n}\n\nbody.dark-mode .bi-gear {\n  color: #ffcc00; /* Amber gear icon for distinction in dark mode */\n}\n\nbody.dark-mode .tooltip {\n  background-color: #444;\n  color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n}\n\nbody.dark-mode .tooltip::before {\n  border-color: transparent #444 transparent transparent;\n}\n\nbody.dark-mode .message-box {\n  color: #e0e0e0;\n}\n\nbody.dark-mode .message-box i {\n  color: #80bfff; /* Lighter blue for icon in dark mode */\n}\n\nbody.dark-mode .chat-history {\n  background-color: #2f2f2f;\n  scrollbar-color: #4f4f4f transparent;\n}\nbody.dark-mode .selected{\n  background-color: #4B4B4B;\n}\nbody.dark-mode .list-item {\n  background-color: #1e1e1e; /* Dark background for list items */\n  color: #e0e0e0; /* Light text for visibility */\n}\n\nbody.dark-mode .list-item:hover {\n  background-color: #3a3a3a; /* Slightly lighter on hover */\n}\n\nbody.dark-mode .list-item.selected {\n  background-color: #3b3b3b; /* Highlighted state for selected list item */\n}\n\nbody.dark-mode .chat-history-header {\n  color: #e0e0e0; /* Light text color for dark mode */\n}\n\nbody.dark-mode .deleteCov {\n  background-color: #3b3b3b; /* Darker background for delete button */\n  color: #ffffff; /* Light text */\n}\n\nbody.dark-mode .deleteCov:hover {\n  background-color: #4b4b4b; /* Slightly lighter background on hover */\n}\n\n/* Dropdown container */\nbody.dark-mode .dropdown-container {\n  background-color: #2a2a2a; /* Dark background for dropdown */\n  color: #e0e0e0; /* Light text for visibility */\n}\n\nbody.dark-mode .dropdown-container:hover {\n  background-color: #3a3a3a; /* Slightly lighter on hover */\n}\n\n\n@media (max-width: 720px) {\n  .sidebar.closed {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
